import { render, staticRenderFns } from "./FBForm.vue?vue&type=template&id=6c4d1358&scoped=true"
import script from "./FBForm.vue?vue&type=script&lang=ts"
export * from "./FBForm.vue?vue&type=script&lang=ts"
import style0 from "./FBForm.vue?vue&type=style&index=0&id=6c4d1358&prod&lang=scss&scoped=true"
import style1 from "./FBForm.vue?vue&type=style&index=1&id=6c4d1358&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4d1358",
  null
  
)

export default component.exports